import * as React from "react"

import { cn } from "@/lib/utils"
import { DatePicker } from "@/components/DatePicker"

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  if (type === "date") {
    const { value, onChange, disabled, placeholder, min, max } = props;
    const testid = props["data-testid"];
    const fromYear = min ? parseInt(String(min).slice(0, 4), 10) : undefined;
    const toYear = max ? parseInt(String(max).slice(0, 4), 10) : undefined;
    return (
      <DatePicker
        value={value || ""}
        onChange={(v) => onChange && onChange({ target: { value: v } })}
        disabled={disabled}
        testid={testid}
        placeholder={placeholder || "Select date"}
        {...(fromYear ? { fromYear } : {})}
        {...(toYear ? { toYear } : {})}
      />
    );
  }
  return (
    <input
      type={type}
      className={cn(
        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
